import API from 'util/API';

export const getQueue = async () => {
  const response = await API.get('/queue');
  return response.data;
};

// status: 'seated' | 'cancelled'
export const finishQueueEntry = async (id, status) => {
  const response = await API.post(`/queue/${encodeURIComponent(id)}/finish`, { status });
  return response.data;
};

// settings: { waitingMinutes?, smsTemplate? }; fields left out are kept.
export const updateQueueSettings = async (settings) => {
  const response = await API.put('/queue/settings', settings);
  return response.data;
};

// Tells the guest their table is ready; calling again re-notifies them.
export const callQueueEntry = async (id) => {
  const response = await API.post(`/queue/${encodeURIComponent(id)}/call`);
  return response.data;
};
